import { typeCreatorV2 } from '../../../redux/utils/common';

//  [REDUCER][TYPE]
export const SET_MESSAGE_OUTGOING_LIST: string = typeCreatorV2(
  'MessageOutgoingReducer',
  'SetMessageOutgoingList'
);

export const SET_MEMBER_STATE_EXCLUDE_CYPRUS: string = typeCreatorV2(
  'MessageOutgoingReducer',
  'SetMemberStateCountriesExcludeCyprus'
);

export const GET_MESSAGE_OUTGOING_XML: string = typeCreatorV2(
  'MessageOutgoingReducer',
  'GetMessageOutgoingXml'
);
